export default __webpack_public_path__ + "static/media/select-many.480ee369.svg";